/*
 * Main and demo navigation arrays
 *
 * 'to' attribute points to the route name, not the path url
 */

export default {
  main: [
    // {
    //   name: "Revenue Dashboard",
    //   to: "dashboard",
    //   icon: "si si-speedometer",
    // },
    // You can also set an external link to your main navigation and it will render as a link
    // {
    //   name: "Link Name",
    //   to: "https://example.com",
    //   icon: "si si-link",
    //   target: "_blank", // You can also set its target property
    // },

    {
      name: 'Statistics',
      heading: true
    },
    {
      name: 'Dashboard',
      to: 'dashboard',
      icon: 'fa fa-tachometer'
    },
    {
      name: 'URL Ranking',
      to: 'ranking',
      icon: 'fa fa-ranking-star'
    },
    {
      name: 'GAM KVP Report',
      to: 'kvp-utm',
      icon: 'fa fa-tag'
    },
    {
      name: 'GAM Hour Report',
      to: 'google-adm-reports',
      icon: 'fab fa-google'
    },
    {
      name: 'GAM AdSpeed',
      to: 'google-adm-adspeed',
      icon: 'fa fa-gauge-high'
    },
    {
      name: 'IVT Report',
      to: 'ivt-report',
      icon: 'fa fa-chart-line'
    },
    {
      name: 'Pricing Rules',
      heading: true
    },
    {
      name: 'Pricing',
      to: 'pricing',
      icon: 'fa fa-magnifying-glass-dollar'
    },
    {
      name: 'Pricing Limits',
      to: 'pricing-limits',
      icon: 'fa fa-dollar-sign'
    },
    {
      name: 'History',
      to: 'pricing-history',
      icon: 'fa fa-hourglass'
    },
    {
      name: 'Dimension Groups',
      to: 'dimension-group',
      icon: 'fa fa-layer-group'
    },
    {
      name: 'URL Types',
      to: 'url-type',
      icon: 'fa fa-link'
    },
    {
      name: 'Settings',
      heading: true
    },
    {
      name: 'Config',
      to: 'config',
      icon: 'fa fa-wrench'
    },
    {
      name: 'History Config',
      to: 'config-history',
      icon: 'fa fa-hourglass'
    },
    {
      name: 'Google Postmaster',
      heading: true
    },
    {
      name: 'Metrics',
      to: 'postmaster',
      icon: 'fa fa-envelope-open'
    }
    // {
    //   name: 'Config',
    //   to: 'postmaster-config',
    //   icon: 'fa fa-wrench'
    // }
  ],
  leadclump: [
    {
      name: 'Lead Clump',
      heading: true
    },
    {
      name: 'Leads Overview',
      to: 'leads-overview',
      icon: 'fa fa-chart-pie'
    },
    {
      name: 'Accounts',
      to: 'lead-clump-account',
      icon: 'fa fa-user-group'
    },
    {
      name: 'Quizzes',
      to: 'lead-clump-quiz',
      icon: 'fa fa-clipboard-question'
    },
    {
      name: 'Weights',
      to: 'lead-clump-weight',
      icon: 'fa fa-scale-balanced'
    },
    {
      name: 'Email Checker',
      to: 'lead-clump-email-checker',
      icon: 'fa fa-envelope-circle-check'
    }
  ],
  googleads: [
    {
      name: 'Google Ads',
      heading: true
    },
    // {
    //   name: 'Accounts',
    //   to: 'google-ads-account',
    //   icon: 'fab fa-google'
    // },
    {
      name: 'Campaigns',
      to: 'google-ads-campaign',
      icon: 'fab fa-google'
    }
    // {
    //   name: 'Config',
    //   to: 'google-ads-config',
    //   icon: 'fa fa-wrench'
    // }
  ],
  homolog: [
    {
      name: 'GAM AdSpeed (Adunit)',
      to: 'google-adm-adspeed-adunit',
      icon: 'fa fa-gauge-high'
    },
    {
      name: 'Facebook Ads [Homolog]',
      heading: true
    },
    {
      name: 'Accounts',
      to: 'facebook-ads-account',
      icon: 'fab fa-facebook'
    },
    {
      name: 'Campaigns',
      to: 'facebook-ads-campaign',
      icon: 'fab fa-facebook'
    },
    // {
    //   name: 'Config',
    //   to: 'facebook-ads-config',
    //   icon: 'fa fa-wrench'
    // },
    {
      name: 'Active Campaign [Homolog]',
      heading: true
    },
    {
      name: 'Config',
      to: 'active-campaign-config',
      icon: 'fa fa-wrench'
    },
    {
      name: 'Metrics Accounts',
      to: 'active-campaign-accounts',
      icon: 'fa fa-address-book'
    },
    {
      name: 'Metrics Campaigns',
      to: 'active-campaign-campaigns',
      icon: 'fa fa-envelope'
    }
  ],
  admin: [
    {
      name: 'Administration',
      heading: true
    },
    {
      name: 'Users',
      to: 'user',
      icon: 'fa fa-user-group'
    },
    {
      name: 'Companies',
      to: 'company',
      icon: 'fa fa-building'
    },
    {
      name: 'Sites',
      to: 'site',
      icon: 'fa fa-globe'
    },
    {
      name: 'Jobs',
      to: 'jobs',
      icon: 'fa fa-server'
    }
  ]
}
